import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const { user, login, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user && user.role === "admin") return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/admin/dashboard");
    else setError(res.error);
  };

  return (
    <main className="min-h-[calc(100vh-4rem)] grid place-items-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 justify-center mb-8">
          <img src="/logo.webp" alt="Matt's Daily Savers" className="h-24 w-24" width="96" height="96" />
        </div>
        <div className="mds-card">
          <h1 className="font-heading font-semibold text-2xl">Admin sign in</h1>
          <p className="text-sm text-[#7A8C84] mt-1">Manage services, blog posts and enquiries.</p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
            <label className="block">
              <span className="text-sm font-medium">Email</span>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mds-input mt-2" data-testid="login-email-input" />
            </label>
            <label className="block">
              <span className="text-sm font-medium">Password</span>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mds-input mt-2" data-testid="login-password-input" />
            </label>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} className="mds-btn mds-btn-primary w-full" data-testid="login-submit">
              {loading ? "Signing in…" : (<><LogIn size={16} /> Sign in</>)}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
